import React from "react"
import { AlertCircle, AlertTriangle, CheckCircle2, Info } from "lucide-react"

const TYPE_TO_VARIANT = {
    info: "info",
    warning: "warning",
    error: "danger",
    success: "success",
}

/** SVG icons so toasts work even when bootstrap-icons webfonts are missing (e.g. lodge build). */
const TYPE_TO_ICON = {
    info: Info,
    warning: AlertTriangle,
    error: AlertCircle,
    success: CheckCircle2,
}

/**
 * @param {{
 *   type?: "info" | "warning" | "error" | "success",
 *   title?: string,
 *   message?: string,
 *   onClose?: () => void,
 * }} props
 */
export default function ToastAlert({
    type = "error",
    title = "",
    message = "",
    onClose = () => {},
}) {
    const variant = TYPE_TO_VARIANT[type] ?? "danger"
    const Icon = TYPE_TO_ICON[type] ?? TYPE_TO_ICON.error

    return (
        <div className={`alert alert-${variant} border-2 shadow mb-0 d-flex`} role="alert">
            <Icon
                className="me-2 flex-shrink-0 align-self-start"
                size={22}
                strokeWidth={2}
                aria-hidden
            />
            <div className="flex-grow-1">
                {title ? <div className="fw-semibold mb-1">{title}</div> : null}
                <div className="mb-0">{message}</div>
            </div>
            <button
                type="button"
                className="btn-close ms-3"
                aria-label="Close"
                onClick={onClose}
            />
        </div>
    )
}
